.action-icon {
  background-color: #31363e;
  padding: 10px 14px;
  line-height: 0;
  border-radius: 1px;
  border: 1px solid #31363e;
}

.action-icon:hover {
  border: 1px solid #82affa;
}

.action-button {
  background: var(--button-primary-color);
  color: white;
  display: inline-block;
  border: none;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
}

.action-button:disabled {
  background: var(--button-disabled-color);
  opacity: 0.6;
  cursor: wait;
}
